import Link from 'next/link'
import Image from 'next/legacy/image'

import styles from './GuideCard.module.css'
import Hublot from '@/assets/img/guides/hublot.png'
import Hotel from '@/assets/svg/hotel.svg'
import Activity from '@/assets/svg/activity.svg'
import Restaurant from '@/assets/svg/restaurant.svg'
import Arrow from '@/assets/svg/back-arrow.svg'

const GuideCard = ({ guide, categories }) => {
  return (
    <Link
      href={`/guides/${guide.slug}`}
      className="block relative p-30 pt-[225px] md:p-60 md:pt-[225px] rounded-20 text-white flex flex-col gap-10 justify-between"
      style={{ backgroundColor: guide.bg_color }}
    >
      <header className="absolute w-[248px] top-[-136px]">
        <Image src={Hublot} alt="Hublot" className="relative z-10" />
        {guide.img && (
          <div className="absolute w-[130px] h-[130px] top-[130px] left-[27px] transform overflow-hidden">
            <Image
              src={`${process.env.NEXT_PUBLIC_BRETZEL}${guide.img.url}`}
              alt={guide.name}
              layout="fill"
            />
          </div>
        )}
      </header>
      <h2 className="title-2">{guide.title}</h2>
      <div className={styles.addresses}>
        <p>{guide.nbPlaces} bonnes adresses</p>
        <ul className="flex flex-row gap-10">
          {categories.map((cat) => (
            <li key={cat.id}>
              {cat.slug.includes('hotel') ? (
                <Hotel width={23} height={26} />
              ) : cat.slug.includes('nourriture') ? (
                <Restaurant width={17} height={25} />
              ) : cat.slug.includes('activite') ? (
                <Activity width={25} height={25} />
              ) : null}
              {<p>x{guide.categoryCounts[cat.id]?.qty || 0}</p>}
            </li>
          ))}
        </ul>
      </div>
      <footer className="flex justify-between mt-30">
        <p className="mr-30 mt-[4px]">
          {guide?.thanks?.length > 0 && (
            <>
              <strong className="font-bold">Merci :</strong> {guide.thanks}
            </>
          )}
        </p>
        <div className="shrink-0 w-30 h-30 rounded-full bg-white text-dark rotate-180 origin-center flex justify-center items-center">
          <Arrow />
        </div>
      </footer>
    </Link>
  )
}

export default GuideCard
